<template>
    <div class="continer">
        <background>
            <div class="logout-btn" @click="logout">退出登录</div>
            <div class="content">
                <div class="aside">
                    <div v-for="(item,index) in asideList" :key="index+'aside'">
                        <div class="func-btn" 
                            :class="selectFunc === item.value ? 'active' : ''"
                            @click="handleClickFunc(item)">{{item.name}}</div>
                    </div>
                </div>
                <div class="form">
                <el-form label-width="200px" :model="startForm">
                    <el-form-item label="选择机构：">
                        <el-select v-model="startForm.orgName" 
                                placeholder="请选择"
                                :popper-append-to-body="false" 
                                popper-class="option-item"
                                @change="changeOrg">
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="selectFunc === 1" label="会计期间：">
                        <el-input readonly v-model="startForm.region"></el-input>
                    </el-form-item>
                    <el-form-item v-else >
                        <!-- 防止页面跳动，占位使用 -->
                    </el-form-item>
                    <el-form-item>
                            <div class="start-btn" @click="startMakeOrder">{{selectFunc === 1 ? '开始制单' : '开始'}}</div>
                    </el-form-item>
                </el-form>
            </div>
            </div>
            
        </background>
        <receiveTicket></receiveTicket>
    </div>
</template>
<script>
import { getOrgList, getBooksInfo,createTask } from '@/api/user'
import {uploadLogs} from '@/api/user'
import { getCookie, setCookie } from '@/utils/auth'
import { debounce } from 'lodash'
import background from '@/components/background'
import receiveTicket from '@/components/receiveTicket'
export default {
    components: {
        background,
        receiveTicket
    },
    data(){
        return {
            startForm:{
                orgName: '',
                region:''
            },
            options: [],
            selectFunc:1,
            asideList: [
                {
                    name:'智能核算',
                    value:1
                },
                {
                    name:'文件上传',
                    value:2
                }
            ]
        }
    },
    mounted(){
        this.getList()
        if(getCookie('orgInfo')){
            this.startForm.orgName = JSON.parse(getCookie('orgInfo')).id
        }
        if(getCookie('account')){
            this.startForm.region = getCookie('account')
        }
        if(getCookie('selectFunc')){
           this.selectFunc = Number(getCookie('selectFunc'))
        }
    },
    methods: {
        getList (){
            getOrgList().then(res => {
                if(res.code === 200){
                    this.options = res.data || []
                }
            })
        },
        changeOrg(val){
            this.getSelectOrg(val)  
            if(this.selectFunc !== 1)return 
            getBooksInfo({orgId: val}).then(res => {
                if(res.code === 200){
                    this.startForm.region = `${res.data.year}年${res.data.month}月`
                    setCookie('account', this.startForm.region)
                    setCookie('booksId', res.data.booksId)
                }
            }).catch(() => {
                this.startForm.region = ''
                setCookie('account', '')
                setCookie('booksId', '')
            }) 
        },
        getSelectOrg(val){
            let selectOrg = ''
            for(let i =0;i<this.options.length;i++){
                if(this.options[i].id === val){
                    selectOrg = this.options[i]
                    setCookie('orgInfo', JSON.stringify(selectOrg))
                    return
                }
            }
        },

        startMakeOrder: debounce(function(){
            if(!this.startForm.orgName){
                return this.$message.error('请选择机构');
            }
            if(this.selectFunc == 1 && !this.startForm.region){
                return this.$message.error('账套信息不存在，请联系财务人员维护账套信息');
            }
            if(this.selectFunc == 1){
                createTask().then(res => {
                    if(res.code === 200){
                        // this.sys.delete({file: '.\\cache'})
                        localStorage.removeItem('imgShowList')
                        localStorage.removeItem('blankImageList')
                        setCookie('selectFunc', this.selectFunc)
                        this.$router.push({name: 'waitScan'})
                    }
                })
            }else {
                localStorage.removeItem('imgShowList')
                localStorage.removeItem('blankImageList')
                setCookie('selectFunc', this.selectFunc)
                this.$router.push({name: 'fileWaitScan'})
            }
            
            
            
        }),
        async logout(){
            uploadLogs({
                content: '按钮触发，主动退出',
                errorCode: 0,
                module: '退出登录'
            }).catch(e => {})
            this.$store.dispatch('LogOut').then(() => {
                this.$router.push({name: 'login'})
            })
        },

        handleClickFunc(item){
            this.selectFunc = item.value
            // 清空机构数据
            this.startForm = {
                orgName: '',
                region:''
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
    }
    .bg {
        height: 100%;
        width: 100%;
        min-height: 100vh; /* 确保至少为视口高度 */
        position: absolute;
        top: 0;
        left: 0;
    }
    .logout-btn {
        position: absolute;
        padding: 17px 22px;
        top: 42px;
        right: 40px;
        background: rgba(239,239,239,0.5);
        border-radius: 8px;
        font-size: 32px;
        text-align: center;
        color: #FFFFFF;
    }
    .content {
        display: flex;
        flex-direction: row;
        height: 100%;
    }
    .aside {
        display: flex;
        flex-direction: column; 
        gap: 20px;
        padding: 40px 20px;
        align-items: center;
        background-color: #f9f9f9;
        border-right: 1px solid #eee;
        .func-btn {
            width: 110px;
            height: 50px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 18px;
            font-weight: 500;
            color: #555;
            background-color: #fff;
            border: 1px solid #ddd;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
        }
        .func-btn:hover {
            background-color: #f0f0f0;
            transform: translateY(-2px);
            border-color: #ccc;
        }
        .func-btn.active {
            background-color: #d32f2f;
            color: white;
            border-color: #d32f2f;
            height: 60px;
            font-weight: bold;
            box-shadow: 0 4px 10px rgba(211, 47, 47, 0.3);
            transform: none;
        }
    }
    .form {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%,-50%);
        /deep/ .el-form-item__label{
            line-height: 87px;
            font-weight: 500;
            font-size: 28px;
            color: rgba(0,0,0,0.85);
        }
         /deep/ input {
            width: 668px;
            height: 87px;
            border-radius: 4px;
            border: 2px solid #DCDCDC;
            font-weight: 500;
            font-size: 26px;
            color: rgba(0,0,0,0.85);
        }
        /deep/ .el-form-item__content{
            width: 668px;
            height: 87px;
            margin-bottom: 59px;
        }
        /deep/ .el-input__icon {
            width: 50px;
        }
        /deep/ .el-select .el-input .el-select__caret {
            font-size: 34px;
        }
    }
    .option-item .el-select-dropdown__item {
        height: 67px !important;
        line-height: 67px !important;
        font-size: 24px !important;
    }
    
    .start-btn {
        width: 668px;
        height: 80px;
        line-height: 80px;
        margin-top: 150px;
        background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
        border-radius: 8px;
        font-size: 28px;
        text-align: center;
        color: #FFFFFF;
    }
</style>

